import React from "react";
import { useState, useEffect } from "react";
import BrandManagement from "./BrandManagement";
import Authentication from "./Authentication";
import OfflineSettings from "./OfflineSettings";
import Notification from "./Notification";
import BackUp from "./BackUp";
import Hierarchy from "./Hierarchy";
import SystemInfo from "./SystemInfo";
import { FaRegSave } from "react-icons/fa";
import { useSettingsUpdate } from "../../hooks/settings/settings.update";
import { useViewSettingsList } from "../../hooks/settings/settings.view";


const Settings = () => {
  const [settingData, setSettingData] = useState({});

  console.log("Current settingData:", settingData); 

  const { data: settingsList } = useViewSettingsList();
    useEffect(() => {
        if (settingsList) {
            setSettingData(settingsList?.data || {});
        }
    }, [settingsList]);


  const settingsUpdateMutation = useSettingsUpdate();

  const handleSubmit = () => {
    settingsUpdateMutation.mutate(
      { body: settingData },
      {
        onSuccess: (data) => {
          alert("Settings saved successfully!");
          console.log("Success:", data);
        },
        onError: (error) => {
          alert("Failed to save settings");
          console.error("Error:", error);
        },
      }
    );
  };

  return (
    <>
      <button
        className="commonButton"
        onClick={handleSubmit}
        style={{ marginLeft: "auto" }}
        disabled={settingsUpdateMutation.isPending}
      >
        <FaRegSave size={20} color="#ffffff" style={{ marginRight: 8 }} /> 
        {settingsUpdateMutation.isPending ? "Saving..." : "Save Changes"}
      </button>

      <BrandManagement data={settingData} setData={setSettingData} />
      <Authentication data={settingData} setData={setSettingData} />
      <OfflineSettings data={settingData} setData={setSettingData} />
      <Notification data={settingData} setData={setSettingData} />
      <BackUp data={settingData} setData={setSettingData} />
      <Hierarchy data={settingData} setData={setSettingData} />
      <SystemInfo data={settingData} setData={setSettingData} />
    </>
  );
};

export default Settings;